import * as service from "../service";

export interface PendingMembership {
  id: string;
  student_id: string;
  society_id: string;
  verified: boolean;
  approved_by: string | null;
  rejected_reason: string | null;
  requested_at: string;
  verified_at: string | null;
  student: {
    id: string;
    user_id: string;
    profile_icon: string | null;
    student_card_image_url: string | null;
    student_card_number: string | null;
    student_card_name: string | null;
    hkid_image_url: string | null;
    hkid_number: string | null;
    hkid_name: string | null;
    university_email: string | null;
    gender: string | null;
    university: string | null;
    year_of_study: string | null;
    identity: string | null;
    phone_num: string | null;
    ctime: string | null;
  };
}

/**
 * Fetch pending membership requests for a society (admin only).
 * Backend: GET /api/society/getPendingMemberships?society_id=
 */
export const GetPendingMembershipsAPI = async (
  society_id: string,
): Promise<PendingMembership[]> => {
  try {
    const resp = await service.call(
      "GET",
      `api/society/getPendingMemberships?society_id=${society_id}`,
    );
    if (resp?.status === 0 && Array.isArray(resp.result)) {
      return resp.result as PendingMembership[];
    }
    return [];
  } catch (err) {
    console.error(`GetPendingMembershipsAPI ${err}`);
    return [];
  }
};